import { render, staticRenderFns } from "./ManageMainPos.vue?vue&type=template&id=fef657f0&scoped=true&"
import script from "./ManageMainPos.vue?vue&type=script&lang=js&"
export * from "./ManageMainPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef657f0",
  null
  
)

export default component.exports